// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","mapPanel":"MapPanel_mapPanel__wCGFL"};